/* lua.js generated code 0.3.1 */

require("clover/def/GameItemDefManager")
require("clover/config/level/TileItem")
require("clover/config/level/TileMoveConfig")

let MapResConfig = require('./MapResConfig')

function addToResMap(resMap, list) {
    list && list.forEach && list.forEach(v => v && (resMap[v] = true))
}

BaseMapData = xClass("BaseMapData")
BaseMapData.prototype.ctor = function () {
    let __VA_ARG = $slice(arguments, 0)
    var self = this
    // body
    self.row = 0
    self.column = 0
    self.isActivity = 0
    self.tileMap = table()
    self.spawn = table()
    self.spawnData = table()
    self.edgeMap = table()
    self.animalMap = null
    self.portals = null
    self.dropRules = null
    self.orderMap = table()
    self.digTileMap = table()
    self.dropBuff = null
    self.path = null
    self.roadType = 0
    self.bossData = null
    self.tileMoveCfg = null
    self.tileMintCfg = null
    self.waterBombData = null
    self.variousBoxData = null
    self.bossAreaData = null
    self.flowerVineLink = table()
    self.furballConfig = null
    self.randomTileDataIndex = table()
    self.surfingCatConfig = table()
    self.colorCollectorConfig = table()
    self.surpriseBoxConfig = table()
    self.surpriseBoxGlobal = table()
    self.snowCordConfig = table()
    self.bigBoxConfig = table()
    self.blockMachineConfig = table()
    self.spawnOtherData = table()
    // self.goldPackageConfig = table()
    self.capsuleToyData = table()
    self.grassData = table()
    self.dinnertableData = table()
    self.laserData = table()
    self.supportStickData = table()
    self.hunterData = table()
    self.safeData = table()
    self.torpedoData = table()
    self.nestData = table()
    self.magicbottleData = table()
    self.cannedFishData = table()
    self.iceBombData = table()
    self.cakeShooterData = table()
    self.sharkData = table()
    self.rocketConfig = table()
    self.minioctopusData = table()
    self.icepopboxData = table()
    self.ufoData = table()
    self.flashBirdConfig = table()
    self.pastryData = table()
    self.jamBoxData = table()
    self.popCanData = table()
    self.fireCrackerData = table()
    self.circusAData = table()
    self.lampLink = table()
    self.turnTileData = table()
}
BaseMapData.prototype.getTileIndex = function (mainLogic, tileList, topLevel) {
    let self = this
    let temp = table()
    for (let k = 1, v = tileList[1]; v; k++ , v = tileList[k]) {
        let canSelect = true
        for (let i = 1, def = v.tileMap[1]; def; i++, def = v.tileMap[i]) {
            let defItem = GameItemDefManager.getDef(def)
            if (defItem.level > topLevel) {
                canSelect = false
                break
            }
        }
        if (canSelect) {
            table.insert(temp, k)
        }
    }
    if ($len(temp) > 0) {
        let index = mainLogic.randomValue(1, $len(temp))
        return temp[index]
    } else {
        return 1
    }
}
BaseMapData.prototype.randomTileDataParse = function (mainLogic, data, topLevel) {
    let self = this
    // body
    for (let k in data.randomTileData) {
        let v = data.randomTileData[k]
        if ($null(v)) continue
        if (data.tileMap[k]) {
            let index
            for (let _k = 1, mapkey = data.tileMap[k][1]; mapkey; _k++, mapkey = data.tileMap[k][_k]) {
                if (mapkey === GameItemDefMapKey.kMigicBox) {
                    index = _k
                    break
                }
            }
            if (index) {
                table.remove(data.tileMap[k], index)
                let tileIndex = self.getTileIndex(mainLogic, v, topLevel)
                self.randomTileDataIndex[k] = tileIndex
                let randomTileData = v[tileIndex]
                for (let _k = 1, mapkey = randomTileData.tileMap[1]; mapkey; _k++, mapkey = randomTileData.tileMap[_k]) {
                    table.insert(data.tileMap[k], mapkey)
                }
                if (randomTileData.waterBombData) {
                    if (!data.waterBombData) {
                        data.waterBombData(table())
                    }
                    data.waterBombData[k] = randomTileData.waterBombData
                }
                if (randomTileData.cakeShooterData) {
                    if (!data.cakeShooterData) {
                        data.cakeShooterData(table())
                    }
                    data.cakeShooterData[k] = randomTileData.cakeShooterData
                }
                if (randomTileData.sharkData) {
                    if (!data.sharkData) {
                        data.sharkData = table()
                    }
                    data.sharkData[k] = randomTileData.sharkData
                }
                if (randomTileData.rocketConfig) {
                    if (!data.rocketConfig) {
                        data.rocketConfig(table())
                    }
                    data.rocketConfig[k] = randomTileData.rocketConfig
                }
                if (randomTileData.minioctopusData) {
                    if (!data.minioctopusData) {
                        data.minioctopusData = table()
                    }
                    data.minioctopusData[k] = randomTileData.minioctopusData
                }
                if (randomTileData.icepopboxData) {
                    if (!data.icepopboxData) {
                        data.icepopboxData = table()
                    }
                    data.icepopboxData[k] = randomTileData.icepopboxData
                }
                if (randomTileData.variousBoxData) {
                    if (!data.variousBoxData) {
                        data.variousBoxData = table()
                    }
                    data.variousBoxData[k] = randomTileData.variousBoxData
                }
                if (randomTileData.ufoData) {
                    if (!data.ufoData) {
                        data.ufoData = table()
                    }
                    data.ufoData[k] = randomTileData.ufoData
                }
                if (randomTileData.spawn) {
                    if (!data.spawn) {
                        data.spawn = table()
                    }
                    data.spawn[k] = randomTileData.spawn
                }
                if (randomTileData.spawnData) {
                    if (!data.spawnData) {
                        data.spawnData = table()
                    }
                    data.spawnData[k] = randomTileData.spawnData
                }
                if (randomTileData.flashBirdConfig) {
                    if (!data.flashBirdConfig) {
                        data.flashBirdConfig = table()
                    }
                    data.flashBirdConfig[k] = randomTileData.flashBirdConfig
                }
                if (randomTileData.pastryData) {
                    if (!data.pastryData) {
                        data.pastryData = table()
                    }
                    data.pastryData[k] = randomTileData.pastryData
                }
                if (randomTileData.jamBoxData) {
                    if (!data.jamBoxData) {
                        data.jamBoxData = table()
                    }
                    data.jamBoxData[k] = randomTileData.jamBoxData
                }
                if (randomTileData.popCanData) {
                    if (!data.popCanData) {
                        data.popCanData = table()
                    }
                    data.popCanData[k] = randomTileData.popCanData
                }
                if (randomTileData.fireCrackerData) {
                    if (!data.fireCrackerData) {
                        data.fireCrackerData = table()
                    }
                    data.fireCrackerData[k] = randomTileData.fireCrackerData
                }
            }
        }
    }
}
BaseMapData.prototype.addRandomTileNeedAssets = function (list, tileData) {
    let self = this
    // body
    for (let k = 1, v = tileData.tileMap[1]; v; k++, v = tileData.tileMap[k]) {
        self.addDependingAssetsByDefId(list, v)
    }
    if (tileData.variousBoxData) {
        self.addDependingAssetsByDefId(list, tileData.variousBoxData.id)
    }
}
BaseMapData.prototype.addDependingAssetsByDefId = function (list, defId) {
    cc.log("addDependingAssetsByDefId", defId)
    let self = this
    // body
    if (MapResConfig.DependingAssetsTypeNameMap[defId]) {
        for (let _ in MapResConfig.DependingAssetsTypeNameMap[defId]) {
            let res = MapResConfig.DependingAssetsTypeNameMap[defId][_]
            if ($null(res)) continue
            list[res] = true
        }
    }
}
BaseMapData.prototype.initWithData = function (mapData) {
    let self = this
    // body
    self.mapData = mapData
    self.loadData(null)
}

BaseMapData.prototype.loadData = function (mainLogic) {
    let self = this
    // body
    let data = self.mapData
    if (mainLogic && self.mapData.randomTileData && $next(self.mapData.randomTileData)) {
        let topLevel = mainLogic.userTopLevel
        data = table.clone(self.mapData)
        self.randomTileDataParse(mainLogic, data, topLevel)
    }

    self.row = data.row
    self.column = data.column
    self.isActivity = data.isActivity
    var tmap = table()
    for (var k in data.tileMap) {
        var v = data.tileMap[k]
        if ($null(v)) continue
        tmap[k] = TileItem.create(v)
    }
    self.tileMap = tmap
    self.spawn = data.spawn
    self.spawnData = data.spawnData
    self.edgeMap = data.edgeMap
    self.portals = data.portals || table()
    self.animalMap = data.specialAnimalMap
    self.dropRules = data.dropRules
    self.trans = data.trans
    self.seaAnimalMap = data.seaAnimalMap
    self.seaFlagMap = data.seaFlagMap
    self.dropBuff = data.dropBuff
    self.waterBombData = data.waterBombData
    self.variousBoxData = data.variousBoxData
    self.bossAreaData = data.bossAreaData
    self.flowerVineLink = data.flowerLink || table()
    self.furballConfig = data.furballConfig || table()
    self.tileMoveCfg = TileMoveConfig.create(data.moveTileCfg)
    self.candyFlossCfg = require("clover/config/level/CandyFlossConfig").create(data.candyFlossCfg)
    self.nestCfg = require("clover/config/level/NestConfig").create(data.nestCfg)
    self.gummyWormCfg = require("clover/config/level/GummyWormConfig").create(data.gummyWormCfg)
    self.candyYoyoCfg = require("clover/config/level/CandyYoyoConfig").create(data.candyYoyoCfg)
    self.tileMintCfg = MintConfig.create(data.mintCfg)
    self.surfingCatConfig = data.surfingCatConfig || table()
    self.colorCollectorConfig = data.colorCollectorConfig || table()
    self.surpriseBoxConfig = data.surpriseBoxConfig || table()
    self.surpriseBoxGlobal = data.surpriseBoxGlobal || table()
    self.snowCordConfig = data.snowCordConfig || table()
    self.bigBoxConfig = data.bigBoxConfig || table()
    self.blockMachineConfig = data.blockMachineData || table()
    self.spawnOtherData = data.spawnOtherData || table()
    self.goldPackageConfig = data.goldPackageConfig || table()
    self.capsuleToyData = data.capsuleToyData || table()
    self.grassData = data.grassData || table()
    self.dinnertableData = data.dinnertableData || table()
    self.laserData = data.laserData || table()
    self.supportStickData = data.supportStickData || table()
    self.hunterData = data.hunterData || table()
    self.safeData = data.safeData || table()
    self.torpedoData = data.torpedoData || table()
    self.nestData = data.nestData || table()
    self.magicbottleData = data.magicbottleData || table()
    self.cannedFishData = data.cannedFishData || table()
    self.iceBombData = data.iceBombData || table()
    self.cakeShooterData = data.cakeShooterData || table()
    self.sharkData = data.sharkData || table()
    self.rocketConfig = data.rocketConfig || table()
    self.minioctopusData = data.minioctopusData || table()
    self.icepopboxData = data.icepopboxData || table()
    self.ufoData = data.ufoData || table()
    self.flashBirdConfig = data.flashBirdConfig || table()
    self.pastryData = data.pastryData || table()
    self.jamBoxData = data.jamBoxData || table()
    self.popCanData = data.popCanData || table()
    self.fireCrackerData = data.fireCrackerData || table()
    self.circusAData = data.circusAData || table()
    self.lampLink = data.lampLink || table()
    self.turnTileData = data.turnTileData || table()
    self.turnTileTileItem = table()
    let keys = table(
        [0, TurnTileConst.kAF],
        [0, TurnTileConst.kAB],
        [0, TurnTileConst.kBF],
        [0, TurnTileConst.kBB]
    )
    for (let _ in keys) {
        let key = keys[_]
        if ($null(key)) continue
        if (!self.turnTileTileItem[key]) {
            self.turnTileTileItem[key] = table()
        }
        if (!self.turnTileData[key]) {
            self.turnTileData[key] = table()
        }
        for (let k in self.turnTileData[key]) {
            let v = self.turnTileData[key][k]
            if ($null(v)) continue
            self.turnTileTileItem[key][k] = TileItem.create(v)
        }
    }
    self.initSpecial(data)
}
BaseMapData.prototype.getEdgeMap = function (rec) {
    var self = this
    if (!rec) {
        return self.edgeMap
    }
    rec = table.clone(rec)
    var edgeMap = table()
    if (!self.edgeMap) {
        return edgeMap
    }
    var crec = cc.rect(rec.x - 0.5, rec.y - 0.5, rec.width + 1, rec.height + 1)
    for (var k in self.edgeMap) {
        var v = self.edgeMap[k]
        if ($null(v)) continue
        var arr = string.split(k, "_")
        if ($len(arr) === 2) {
            var [row, col] = [tonumber(arr[1]), tonumber(arr[2])]
            if (cc.rectContainsPoint(crec, cc.p(row, col))) {
                edgeMap[(row - rec.x + 1) + "_" + (col - rec.y + 1)] = v
            }
        }
    }
    return edgeMap
}
BaseMapData.prototype.getFlowerVineLinkMap = function (rec) {
    var self = this
    // body
    if (!rec) {
        return self.flowerVineLink
    }
    var linkmap = table()
    for (var k in self.flowerVineLink) {
        var v = self.flowerVineLink[k]
        if ($null(v)) continue
        var [r1, c1] = [v[1], v[2]]
        let [r2, c2] = [v[3], v[4]]
        if (cc.rectContainsPoint(rec, cc.p(r1, c1)) && cc.rectContainsPoint(rec, cc.p(r2, c2))) {
            r1 = r1 - rec.x + 1
            c1 = c1 - rec.y + 1
            r2 = r2 - rec.x + 1
            c2 = c2 - rec.y + 1
            table.insert(linkmap, table(
                [1, "r1", r1],
                [1, "c1", c1],
                [1, "r2", r2],
                [1, "c2", c2]
            ))
        }
    }
    return linkmap
}
BaseMapData.prototype.getLampLinkMap = function (rec) {
    let self = this
    // body
    if (!rec) {
        return self.lampLink
    }
    let linkmap = table()
    for (let k in self.lampLink) {
        let v = self.lampLink[k]
        if ($null(v)) continue
        let [r1, c1] = [v[1], v[2]]
        let [r2, c2] = [v[3], v[4]]
        if (cc.rectContainsPoint(rec, cc.p(r1, c1)) && cc.rectContainsPoint(rec, cc.p(r2, c2))) {
            r1 = r1 - rec.x + 1
            c1 = c1 - rec.y + 1
            r2 = r2 - rec.x + 1
            c2 = c2 - rec.y + 1
            table.insert(linkmap, table(
                [1, "r1", r1],
                [1, "c1", c1],
                [1, "r2", r2],
                [1, "c2", c2]
            ))
        }
    }
    return linkmap
}
BaseMapData.prototype.getTileData = function (rec) {
    var self = this
    if (!rec) {
        return self.tileMap
    }
    var tileMap = table()
    if (!self.tileMap) {
        return tileMap
    }
    var $limit25 = rec.width
    for (var row = 0; row <= $limit25; row += 1) {
        var $limit28 = rec.height
        for (var col = 0; col <= $limit28; col += 1) {
            var k = (row + rec.x) + "_" + (col + rec.y)
            tileMap[(row + 1) + "_" + (col + 1)] = self.tileMap[k]
        }
    }
    return tileMap
}
BaseMapData.prototype.getSpawn = function (rec) {
    var self = this
    if (!rec) {
        return self.spawn
    }
    var spawn = table()
    if (!self.spawn) {
        return spawn
    }
    for (var k in self.spawn) {
        var v = self.spawn[k]
        if ($null(v)) continue
        var arr = string.split(k, "_")
        if ($len(arr) === 2) {
            var [row, col] = [tonumber(arr[1]), tonumber(arr[2])]
            if (cc.rectContainsPoint(rec, cc.p(row, col))) {
                spawn[(row - rec.x + 1) + "_" + (col - rec.y + 1)] = v
            }
        }
    }
    return spawn
}
BaseMapData.prototype.getSpawnData = function (rec) {
    var self = this
    if (!rec) {
        return self.spawnData
    }
    var spawnData = table()
    if (!self.spawnData) {
        return spawnData
    }
    for (var k in self.spawnData) {
        var v = self.spawnData[k]
        if ($null(v)) continue
        var arr = string.split(k, "_")
        if ($len(arr) === 2) {
            var [row, col] = [tonumber(arr[1]), tonumber(arr[2])]
            if (cc.rectContainsPoint(rec, cc.p(row, col))) {
                spawnData[(row - rec.x + 1) + "_" + (col - rec.y + 1)] = v
            }
        }
    }
    return spawnData
}
BaseMapData.prototype.getSpawnOtherData = function (rec) {
    let self = this
    if (!rec) {
        return self.spawnOtherData
    }
    let spawnOtherData = table()
    if (!self.spawnOtherData) {
        return spawnOtherData
    }
    for (let k in self.spawnOtherData) {
        let v = self.spawnOtherData[k]
        if ($null(v)) continue
        let arr = k.split("_")
        if ($len(arr) === 2) {
            let [row, col] = [tonumber(arr[0]), tonumber(arr[1])]
            if (cc.rectContainsPoint(rec, cc.p(row, col))) {
                spawnOtherData[(row - rec.x + 1) + "_" + (col - rec.y + 1)] = v
            }
        }
    }
    return spawnOtherData
}
BaseMapData.prototype.getPath = function (rec) {
    var self = this
    if (!rec) {
        return self.path
    }
    var path = table()
    if (!self.path) {
        return path
    }
    //---兼容老的地图配置
    var map = self.path.map || self.path
    if (self.column > GamePlayConfig_Max_C) {
        for (var k in map) {
            let v = map[k]
            if ($null(v)) continue
            let varr = table()
            for (let idx in v) {
                let parr = v[idx]
                if ($null(parr)) continue
                if (cc.rectContainsPoint(rec, cc.p(parr[1], parr[2]))) {
                    table.insert(varr, table(
                        [0, parr[1] - rec.x + 1],
                        [0, parr[2] - rec.y + 1],
                        [0, parr[3]]
                    ))
                } else if ($len(varr) > 0) {
                    break
                }
            }
            if ($len(varr) > 0) {
                table.insert(path, varr)
            }
        }
    } else {
        for (let k in map) {
            let v = map[k]
            if ($null(v)) continue
            var varr = table()
            var bool = true
            for (var idx in v) {
                var parr = v[idx]
                if ($null(parr)) continue
                table.insert(varr, table(
                    [0, parr[1] - rec.x + 1],
                    [0, parr[2] - rec.y + 1],
                    [0, parr[3]]
                ))
                if (!cc.rectContainsPoint(rec, cc.p(parr[1], parr[2]))) {
                    bool = false
                    break
                }
            }
            if (bool) {
                table.insert(path, varr)
            }
        }
    }
    function combinPath(path, r1, c1, r2, c2) {
        // body
        var t1, t2
        for (var k = 1, v = path[1]; v; k++ , v = path[k]) {
            var size = $len(v)
            if ((v[size][1] === r1 && v[size][2] === c1)) {
                t1 = table.remove(path, k)
            }
        }
        for (var k = 1, v = path[1]; v; k++ , v = path[k]) {
            if ((v[1][1] === r2 && v[1][2] === c2)) {
                t2 = table.remove(path, k)
            }
        }
        if (t1 && t2) {
            for (var k = 1, v = t2[1]; v; k++ , v = t2[k]) {
                table.insert(t1, v)
            }
            table.insert(path, t1)
        } else if (t1) {
            table.insert(path, t1)
        } else if (t2) {
            table.insert(path, t2)
        }
    }
    if (self.path.link && $len(self.path.link) > 0) {
        for (var k = 1, v = self.path.link[1]; v; k++ , v = self.path.link[k]) {
            combinPath(path, v.sr, v.sc, v.er, v.ec)
        }
    }
    return path
}
BaseMapData.prototype.getPortal = function (rec) {
    var self = this
    if (!rec) {
        return self.portals
    }
    var portals = table()
    if (!self.portals) {
        return portals
    }
    for (var k in self.portals) {
        var v = self.portals[k]
        if ($null(v)) continue
        if (cc.rectContainsPoint(rec, cc.p(v[1][2], v[1][1])) || cc.rectContainsPoint(rec, cc.p(v[2][2], v[2][1]))) {
            table.insert(portals, table([0, table([0, v[1][1] - rec.y + 1], [0, v[1][2] - rec.x + 1])], [0, table([0, v[2][1] - rec.y + 1], [0, v[2][2] - rec.x + 1])]))
        }
    }
    return portals
}
BaseMapData.prototype.getTran = function (rec) {
    var self = this
    if (!rec) {
        return self.trans
    }
    var trans = table()
    if (!self.trans) {
        return trans
    }
    for (var k in self.trans) {
        var v = self.trans[k]
        if ($null(v)) continue
        var transItem = BaseTransmission.create(v).getHeadTrans()
        var headTrans = transItem
        var transvs = table()
        var bool = true
        while ((transItem != null)) {
            var start = transItem.getStart()
            var ed = transItem.getEnd()
            var link = transItem.getLink()
            if (!cc.rectContainsPoint(rec, start) || !cc.rectContainsPoint(rec, ed) || ((link.x !== 0 || link.y !== 0) && !cc.rectContainsPoint(rec, link))) {
                bool = false
                break
            }
            var transv = table()
            transv.begin = table([0, transItem.startItem.x - rec.x + 1], [0, transItem.startItem.y - rec.y + 1])
            transv.beginType = transItem.startType
            transv.terminal = table([0, transItem.endItem.x - rec.x + 1], [0, transItem.endItem.y - rec.y + 1])
            transv.terminalType = transItem.endType
            if (transItem.toItem.x === 0 && transItem.toItem.y === 0) {
                transv.link = table(0, 0)
            } else {
                transv.link = table([0, transItem.toItem.x - rec.x + 1], [0, transItem.toItem.y - rec.y + 1])
            }
            transv.singdir = transItem.singdir
            table.insert(transvs, transv)
            transItem = transItem.getNextTrans()
        }
        if (bool) {
            table.insert(trans, transvs)
        }
    }
    return trans
}
BaseMapData.prototype.getWaterBomb = function (rec) {
    var self = this
    if (!rec) {
        return self.waterBombData
    }
    var waterBombData = table()
    if (!self.waterBombData) {
        return waterBombData
    }
    for (var k in self.waterBombData) {
        var v = self.waterBombData[k]
        if ($null(v)) continue
        var arr = string.split(k, "_")
        if ($len(arr) === 2) {
            var [row, col] = [tonumber(arr[1]), tonumber(arr[2])]
            if (cc.rectContainsPoint(rec, cc.p(row, col))) {
                waterBombData[(row - rec.x + 1) + "_" + (col - rec.y + 1)] = v
            }
        }
    }
    return waterBombData
}
BaseMapData.prototype.getCakeShooterData = function (rec) {
    let self = this
    if (!rec) {
        return self.cakeShooterData
    }
    let cakeShooterData = table()
    if (!self.cakeShooterData) {
        return cakeShooterData
    }
    for (let k in self.cakeShooterData) {
        let v = self.cakeShooterData[k]
        if ($null(v)) continue
        let arr = string.split(k, "_")
        if ($len(arr) === 2) {
            let [row, col] = [tonumber(arr[1]), tonumber(arr[2])]
            if (cc.rectContainsPoint(rec, cc.p(row, col))) {
                cakeShooterData[(row - rec.x + 1) + "_" + (col - rec.y + 1)] = v
            }
        }
    }
    return cakeShooterData
}
BaseMapData.prototype.getSharkData = function (rec) {
    let self = this
    if (!rec) {
        return self.sharkData
    }
    let sharkData = table()
    if (!self.sharkData) {
        return sharkData
    }
    for (let k in self.sharkData) {
        let v = self.sharkData[k]
        if ($null(v)) continue
        let arr = string.split(k,"_")
        if ($len(arr) === 2) {
            let [row, col] = [tonumber(arr[1]), tonumber(arr[2])]
            if (cc.rectContainsPoint(rec, cc.p(row, col))) {
                sharkData[(row - rec.x + 1) + "_" + (col - rec.y + 1)] = v
            }
        }
    }
    return sharkData
}
BaseMapData.prototype.getRocketConfig = function (rect) {
    let self = this
    if (!rect) {
        return self.rocketConfig
    }
    let rocketConfig = table()
    if (!self.rocketConfig) {
        return rocketConfig
    }
    for (let k in self.rocketConfig) {
        let v = self.rocketConfig[k]
        if ($null(v)) continue
        let arr = k.split("_")
        if ($len(arr) === 2) {
            let [row, col] = [tonumber(arr[0]), tonumber(arr[1])]
            if (cc.rectContainsPoint(rect, cc.p(row, col))) {
                rocketConfig[(row - rect.x + 1) + "_" + (col - rect.y + 1)] = v
            }
        }
    }
    return rocketConfig
}
BaseMapData.prototype.getMiniOctopusData = function (rect) {
    let self = this
    if (!rect) {
        return self.minioctopusData
    }
    let minioctopusData = table()
    if (!self.minioctopusData) {
        return minioctopusData
    }
    for (let k in self.minioctopusData) {
        let v = self.minioctopusData[k]
        if ($null(v)) continue
        let arr = string.split(k, "_")
        if ($len(arr) === 2) {
            let [row, col] = [tonumber(arr[1]), tonumber(arr[2])]
            if (cc.rectContainsPoint(rect, cc.p(row, col))) {
                minioctopusData[(row - rect.x + 1) + "_" + (col - rect.y + 1)] = v
            }
        }
    }
    return minioctopusData
}
BaseMapData.prototype.getIcePopBoxData = function (rect) {
    let self = this
    if (!rect) {
        return self.icepopboxData
    }
    let icepopboxData = table()
    if (!self.icepopboxData) {
        return icepopboxData
    }
    for (let k in self.icepopboxData) {
        let v = self.icepopboxData[k]
        if ($null(v)) continue
        let arr = string.split(k, "_")
        if ($len(arr) === 2) {
            let [row, col] = [tonumber(arr[1]), tonumber(arr[2])]
            if (cc.rectContainsPoint(rect, cc.p(row, col))) {
                icepopboxData[(row - rect.x + 1) + "_" + (col - rect.y + 1)] = v
            }
        }
    }
    return icepopboxData
}
BaseMapData.prototype.getVariousBox = function (rec) {
    let self = this
    if (!rec) {
        return self.variousBoxData
    }
    var variousBoxData = table()
    if (!self.variousBoxData) {
        return variousBoxData
    }
    for (var k in self.variousBoxData) {
        var v = self.variousBoxData[k]
        if ($null(v)) continue
        let arr = string.split(k, "_")
        if ($len(arr) === 2) {
            var [row, col] = [tonumber(arr[1]), tonumber(arr[2])]
            if (cc.rectContainsPoint(rec, cc.p(row, col))) {
                variousBoxData[(row - rec.x + 1) + "_" + (col - rec.y + 1)] = v
            }
        }
    }
    return variousBoxData
}
BaseMapData.prototype.getUFO = function (rec) {
    let self = this
    if (!rec) {
        return self.ufoData
    }
    let ufoData = table()
    if (!self.ufoData) {
        return ufoData
    }
    for (let k in self.ufoData) {
        let v = self.ufoData[k]
        if ($null(v)) continue
        let arr = string.split(k, "_")
        if ($len(arr) === 2) {
            let [row, col] = [tonumber(arr[1]), tonumber(arr[2])]
            if (cc.rectContainsPoint(rec, cc.p(row, col))) {
                ufoData[(row - rec.x + 1) + "_" + (col - rec.y + 1)] = v
            }
        }
    }
    return ufoData
}
BaseMapData.prototype.getPastry = function (rec) {
    let self = this
    if (!rec) {
        return self.pastryData
    }
    let pastryData = table()
    if (!self.pastryData) {
        return pastryData
    }
    for (let k in self.pastryData) {
        let v = self.pastryData[k]
        if ($null(v)) continue
        let arr = k.split("_")
        if ($len(arr) === 2) {
            let [row, col] = [tonumber(arr[0]), tonumber(arr[1])]
            if (cc.rectContainsPoint(rec, cc.p(row, col))) {
                pastryData[(row - rec.x + 1) + "_" + (col - rec.y + 1)] = v
            }
        }
    }
    return pastryData
}
BaseMapData.prototype.getJamBox = function (rec) {
    let self = this
    if (!rec) {
        return self.jamBoxData
    }
    let jamBoxData = table()
    if (!self.jamBoxData) {
        return jamBoxData
    }
    for (let k in self.jamBoxData) {
        let v = self.jamBoxData[k]
        if ($null(v)) continue
        let arr = string.split(k, "_")
        if ($len(arr) === 2) {
            let [row, col] = [tonumber(arr[1]), tonumber(arr[2])]
            if (cc.rectContainsPoint(rec, cc.p(row, col))) {
                jamBoxData[(row - rec.x + 1) + "_" + (col - rec.y + 1)] = v
            }
        }
    }
    return jamBoxData
}
BaseMapData.prototype.getCapsuleToyData = function (rec) {
    let self = this
    if (!rec) {
        return self.capsuleToyData
    }
    let capsuleToyData = table()
    if (!self.capsuleToyData) {
        return capsuleToyData
    }
    for (let k in self.capsuleToyData) {
        let v = self.capsuleToyData[k]
        if ($null(v)) continue
        let arr = string.split(k, "_")
        if ($len(arr) === 2) {
            let [row, col] = [tonumber(arr[1]), tonumber(arr[2])]
            if (cc.rectContainsPoint(rec, cc.p(row, col))) {
                capsuleToyData[(row - rec.x + 1) + "_" + (col - rec.y + 1)] = v
            }
        }
    }
    return capsuleToyData
}
BaseMapData.prototype.getGrassData = function (rec) {
    let self = this
    if (!rec) {
        return self.grassData
    }
    let grassData = table()
    if (!self.grassData) {
        return grassData
    }
    for (let k in self.grassData) {
        let v = self.grassData[k]
        if ($null(v)) continue
        let arr = string.split(k, "_")
        if ($len(arr) === 2) {
            let [row, col] = [tonumber(arr[1]), tonumber(arr[2])]
            if (cc.rectContainsPoint(rec, cc.p(row, col))) {
                grassData[(row - rec.x + 1) + "_" + (col - rec.y + 1)] = v
            }
        }
    }
    return grassData
}
BaseMapData.prototype.getTurnTileData = function (rec) {
    let self = this
    if (!rec) {
        return self.turnTileData
    }
    let turnTileData = table(
        [1, TurnTileConst.kA, 1],
        [1, TurnTileConst.kB, 1],
        [1, TurnTileConst.kAF, table()],
        [1, TurnTileConst.kAB, table()],
        [1, TurnTileConst.kBF, table()],
        [1, TurnTileConst.kBB, table()]
    )
    if (!self.turnTileData) {
        return turnTileData
    }
    let keys = table(
        [0, TurnTileConst.kAF],
        [0, TurnTileConst.kAB],
        [0, TurnTileConst.kBF],
        [0, TurnTileConst.kBB]
    )
    for (let _ in keys) {
        let key = keys[_]
        if ($null(key)) continue
        for (let k in self.turnTileData[key]) {
            let v = self.turnTileData[key][k]
            if ($null(v)) continue
            let arr = string.split(k, "_")
            if ($len(arr) === 2) {
                let [row, col] = [tonumber(arr[1]), tonumber(arr[2])]
                if (cc.rectContainsPoint(rec, cc.p(row, col))) {
                    turnTileData[key][(row - rec.x + 1) + "_" + (col - rec.y + 1)] = v
                }
            }
        }
    }
    turnTileData[TurnTileConst.kA] = self.turnTileData[TurnTileConst.kA]
    turnTileData[TurnTileConst.kB] = self.turnTileData[TurnTileConst.kB]
    return turnTileData
}
BaseMapData.prototype.getDinnertableData = function (rec) {
    let self = this
    if (!rec) {
        return self.dinnertableData
    }
    let dinnertableData = table()
    if (!self.dinnertableData) {
        return dinnertableData
    }
    for (let k in self.dinnertableData) {
        let v = self.dinnertableData[k]
        if ($null(v)) continue
        let arr = string.split(k, "_")
        if ($len(arr) === 2) {
            let [row, col] = [tonumber(arr[1]), tonumber(arr[2])]
            if (cc.rectContainsPoint(rec, cc.p(row, col))) {
                dinnertableData[(row - rec.x + 1) + "_" + (col - rec.y + 1)] = v
            }
        }
    }
    return dinnertableData
}
BaseMapData.prototype.getLaserData = function (rec) {
    let self = this
    if (!rec) {
        return self.laserData
    }
    let laserData = table()
    if (!self.laserData) {
        return laserData
    }
    for (let k in self.laserData) {
        let v = self.laserData[k]
        
        if ($null(v)) continue
        //let arr = k.split("_")
        let arr = string.split(k, "_")
        if ($len(arr) == 2) {
            let [row, col] = [tonumber(arr[1]), tonumber(arr[2])]
            if (cc.rectContainsPoint(rec, cc.p(row, col))) {
                laserData[(row - rec.x + 1) + "_" + (col - rec.y + 1)] = v
            }
        }
    }
    return laserData
}
BaseMapData.prototype.getSupportStickData = function (rec) {
    let self = this
    if (!rec) {
        return self.supportStickData
    }
    let supportStickData = table()
    if (!self.supportStickData) {
        return supportStickData
    }
    for (let k in self.supportStickData) {
        let v = self.supportStickData[k]
        if ($null(v)) continue
        let arr = string.split(k, "_")
        if ($len(arr) == 2) {
            let [row, col] = [tonumber(arr[1]), tonumber(arr[2])]
            if (cc.rectContainsPoint(rec, cc.p(row, col))) {
                supportStickData[(row - rec.x + 1) + "_" + (col - rec.y + 1)] = v
            }
        }
    }
    return supportStickData
}
BaseMapData.prototype.getHunterData = function (rec) {
    let self = this
    if (!rec) {
        return self.hunterData
    }
    let hunterData = table()
    if (!self.hunterData) {
        return hunterData
    }
    for (let k in self.hunterData) {
        let v = self.hunterData[k]
        if ($null(v)) continue
        // let arr = k.split("_")
        let arr = string.split(k, "_")
        if ($len(arr) === 2) {
            let [row, col] = [tonumber(arr[1]), tonumber(arr[2])]
            if (cc.rectContainsPoint(rec, cc.p(row, col))) {
                hunterData[(row - rec.x + 1) + "_" + (col - rec.y + 1)] = v
            }
        }
    }
    return hunterData
}
BaseMapData.prototype.getSafeData = function (rec) {
    let self = this
    if (!rec) {
        return self.safeData
    }
    let safeData = table()
    if (!self.safeData) {
        return safeData
    }
    for (let k in self.safeData) {
        let v = self.safeData[k]
        if ($null(v)) continue
        // let arr = k.split("_")
        let arr = string.split(k, "_")
        if ($len(arr) === 2) {
            let [row, col] = [tonumber(arr[1]), tonumber(arr[2])]
            if (cc.rectContainsPoint(rec, cc.p(row, col))) {
                safeData[(row - rec.x + 1) + "_" + (col - rec.y + 1)] = v
            }
        }
    }
    return safeData
}
BaseMapData.prototype.getTorpedoData = function (rec) {
    let self = this
    if (!rec) {
        return self.torpedoData
    }
    let torpedoData = table()
    if (!self.torpedoData) {
        return torpedoData
    }
    for (let k in self.torpedoData) {
        let v = self.torpedoData[k]
        if ($null(v)) continue
        // let arr = k.split("_")
        let arr = string.split(k, "_")
        if ($len(arr) === 2) {
            let [row, col] = [tonumber(arr[1]), tonumber(arr[2])]
            if (cc.rectContainsPoint(rec, cc.p(row, col))) {
                torpedoData[(row - rec.x + 1) + "_" + (col - rec.y + 1)] = v
            }
        }
    }
    return torpedoData
}
BaseMapData.prototype.getMagicbottleData = function (rec) {
    let self = this
    if (!rec) {
        return self.magicbottleData
    }
    let magicbottleData = table()
    if (!self.magicbottleData) {
        return magicbottleData
    }
    for (let k in self.magicbottleData) {
        let v = self.magicbottleData[k]
        if ($null(v)) continue
        // let arr = k.split("_")
        let arr = string.split(k, "_")
        if ($len(arr) === 2) {
            let [row, col] = [tonumber(arr[1]), tonumber(arr[2])]
            if (cc.rectContainsPoint(rec, cc.p(row, col))) {
                magicbottleData[(row - rec.x + 1) + "_" + (col - rec.y + 1)] = v
            }
        }
    }
    return magicbottleData
}
BaseMapData.prototype.getCannedFishData = function (rec) {
    let self = this
    if (!rec) {
        return self.cannedFishData
    }
    let cannedFishData = table()
    if (!self.cannedFishData) {
        return cannedFishData
    }
    for (let k in self.cannedFishData) {
        let v = self.cannedFishData[k]
        if ($null(v)) continue
        // let arr = k.split("_")
        let arr = string.split(k, "_")
        if ($len(arr) === 2) {
            let [row, col] = [tonumber(arr[1]), tonumber(arr[2])]
            if (cc.rectContainsPoint(rec, cc.p(row, col))) {
                cannedFishData[(row - rec.x + 1) + "_" + (col - rec.y + 1)] = v
            }
        }
    }
    return cannedFishData
}
BaseMapData.prototype.getIceBombData = function (rec) {
    let self = this
    if (!rec) {
        return self.iceBombData
    }
    let iceBombData = table()
    if (!self.iceBombData) {
        return iceBombData
    }
    for (let k in self.iceBombData) {
        let v = self.iceBombData[k]
        if ($null(v)) continue
        let arr = string.split(k, "_")
        if ($len(arr) === 2) {
            let [row, col] = [tonumber(arr[1]), tonumber(arr[2])]
            if (cc.rectContainsPoint(rec, cc.p(row, col))) {
                iceBombData[(row - rec.x + 1) + "_" + (col - rec.y + 1)] = v
            }
        }
    }
    return iceBombData
}
BaseMapData.prototype.getPopCanData = function (rec) {
    let self = this
    if (!rec) {
        return self.popCanData
    }
    let popCanData = table()
    if (!self.popCanData) {
        return popCanData
    }
    for (let k in self.popCanData) {
        let v = self.popCanData[k]
        if ($null(v)) continue
        let arr = k.split("_")
        if ($len(arr) === 2) {
            let [row, col] = [tonumber(arr[0]), tonumber(arr[1])]
            if (cc.rectContainsPoint(rec, cc.p(row, col))) {
                popCanData[(row - rec.x + 1) + "_" + (col - rec.y + 1)] = v
            }
        }
    }
    return popCanData
}
BaseMapData.prototype.getFireCrackerData = function (rec) {
    let self = this
    if (!rec) {
        return self.fireCrackerData
    }
    let fireCrackerData = table()
    if (!self.fireCrackerData) {
        return fireCrackerData
    }
    for (let k in self.fireCrackerData) {
        let v = self.fireCrackerData[k]
        if ($null(v)) continue
        let arr = k.split("_")
        if ($len(arr) === 2) {
            let [row, col] = [tonumber(arr[0]), tonumber(arr[1])]
            if (cc.rectContainsPoint(rec, cc.p(row, col))) {
                fireCrackerData[(row - rec.x + 1) + "_" + (col - rec.y + 1)] = v
            }
        }
    }
    return fireCrackerData
}
BaseMapData.prototype.getCircusAData = function (rec) {
    let self = this
    if (!rec) {
        return self.circusAData
    }
    let circusAData = table()
    if (!self.circusAData) {
        return circusAData
    }
    for (let k in self.circusAData) {
        let v = self.circusAData[k]
        if ($null(v)) continue
        let arr = string.split(k, "_")
        if ($len(arr) === 2) {
            let [row, col] = [tonumber(arr[1]), tonumber(arr[2])]
            if (cc.rectContainsPoint(rec, cc.p(row, col))) {
                circusAData[(row - rec.x + 1) + "_" + (col - rec.y + 1)] = v
            }
        }
    }
    return circusAData
}
BaseMapData.prototype.getBossAreaData = function (rec) {
    var self = this
    if (!rec) {
        return self.bossAreaData
    }
    var bossAreaData = table()
    if (!self.bossAreaData) {
        return bossAreaData
    }
    for (var k in self.bossAreaData) {
        var v = self.bossAreaData[k]
        if ($null(v)) continue
        let arr = string.split(k, "_")
        if ($len(arr) === 2) {
            var [row, col] = [tonumber(arr[1]), tonumber(arr[2])]
            if (cc.rectContainsPoint(rec, cc.p(row, col))) {
                bossAreaData[(row - rec.x + 1) + "_" + (col - rec.y + 1)] = v
            }
        }
    }
    return bossAreaData
}
BaseMapData.prototype.getTileMoveCfg = function (rec) {
    var self = this
    // body
    if (!rec) {
        return self.tileMoveCfg
    }
    if (!self.tileMoveCfg) {
        return table()
    }
    var result = table()
    for (var k in self.tileMoveCfg.tileMoveCfgs) {
        var v = self.tileMoveCfg.tileMoveCfgs[k]
        if ($null(v)) continue
        var arr = string.split(k, "_")
        var [r, c] = [tonumber(arr[1]), tonumber(arr[2])]
        if (cc.rectContainsPoint(rec, cc.p(r, c))) {
            result[(r - rec.x + 1) + "_" + (c - rec.y + 1)] = v
            v.transForRect(rec)
        }
    }
    return result
}
BaseMapData.prototype.getTileMintCfg = function (rec) {
    let self = this
    if (!rec) {
        return [self.tileMintCfg, null]
    }
    if (!self.tileMintCfg) {
        return [table(), null]
    }
    let [result, tmpMap] = [table(), table()]
    let spot_list
    for (let k in self.tileMintCfg.tileMintCfgs) {
        let v = self.tileMintCfg.tileMintCfgs[k]
        if ($null(v)) continue
        let arr = string.split(k, "_")
        let [r, c] = [tonumber(arr[1]), tonumber(arr[2])]
        let origin_r = r - rec.x + 1
        let origin_c = c - rec.y + 1
        if (!spot_list) {
            spot_list = table()
        }
        if (!spot_list[origin_r + "_" + origin_c]) {
            spot_list[origin_r + "_" + origin_c] = table()
            tmpMap = table()
        }
        if (cc.rectContainsPoint(rec, cc.p(r, c))) {
            result[(r - rec.x + 1) + "_" + (c - rec.y + 1)] = v
            v.transForRect(rec)
            for (let _ = 1, meta = v.routes[1]; meta; _++, meta = v.routes[_]) {
                let [retR, retC] = [origin_r, origin_c]
                while (true) {
                    ;[retR, retC, leftStep] = meta.moveWithStep(retR, retC, 1, false)
                    if (!tmpMap[tostring(retR) + "_" + tostring(retC)]) {
                        table.insert(spot_list[origin_r + "_" + origin_c], table([1, "r", retR], [1, "c", retC]))
                        tmpMap[tostring(retR) + "_" + tostring(retC)] = true
                    }
                    if (leftStep > 0) {
                        break
                    }
                }
            }
        }
    }
    console.log(table.tostring(spot_list))
    // FIXME: multi result
    return [result, spot_list]
}
BaseMapData.prototype.getCandyFlossCfg = function (rec) {
    let self = this
    // body
    if (!rec) {
        return self.candyFlossCfg
    }
    if (!self.candyFlossCfg) {
        return table()
    }
    let result = table()
    for (let k in self.candyFlossCfg.candyFlossCfgs) {
        let v = self.candyFlossCfg.candyFlossCfgs[k]
        if ($null(v)) continue
        let arr = string.split(k, "_")
        let [r, c] = [tonumber(arr[1]), tonumber(arr[2])]
        if (cc.rectContainsPoint(rec, cc.p(r, c))) {
            let key = string.format("%d_%d", r - rec.x + 1, c - rec.y + 1)
            result[key] = v
            v.transForRect(rec)
        }
    }
    return result
}
BaseMapData.prototype.getNestCfg = function (rec) {
    let self = this
    // body
    if (!rec) {
        return self.nestCfg
    }
    if (!self.nestCfg) {
        return table()
    }
    let result = table()
    for (let k in self.nestCfg.nestCfgs) {
        let v = self.nestCfg.nestCfgs[k]
        if ($null(v)) continue
        let arr = string.split(k, "_")
        let [r, c] = [tonumber(arr[1]), tonumber(arr[2])]
        if (cc.rectContainsPoint(rec, cc.p(r, c))) {
            let key = string.format("%d_%d", r - rec.x + 1, c - rec.y + 1)
            result[key] = v
            v.transForRect(rec)
        }
    }
    return result
}
BaseMapData.prototype.getNestData = function (rec) {
    let self = this
    if (!rec) {
        return self.nestData
    }
    let nestData = table()
    if (!self.nestData) {
        return nestData
    }
    for (let k in self.nestData) {
        let v = self.nestData[k]
        if ($null(v)) continue
        // let arr = k.split("_")
        let arr = string.split(k, "_")
        if ($len(arr) === 2) {
            let [row, col] = [tonumber(arr[1]), tonumber(arr[2])]
            if (cc.rectContainsPoint(rec, cc.p(row, col))) {
                nestData[(row - rec.x + 1) + "_" + (col - rec.y + 1)] = v
            }
        }
    }
    return nestData
}
BaseMapData.prototype.getCandyYoyoCfg = function (rec) {
    let self = this
    // body
    if (!rec) {
        return self.candyYoyoCfg
    }
    if (!self.candyYoyoCfg) {
        return table()
    }
    let result = table()
    for (let k in self.candyYoyoCfg.candyYoyoCfgs) {
        let v = self.candyYoyoCfg.candyYoyoCfgs[k]
        if ($null(v)) continue
        let arr = string.split(k, "_")
        let [r, c] = [tonumber(arr[1]), tonumber(arr[2])]
        if (cc.rectContainsPoint(rec, cc.p(r, c))) {
            let key = string.format("%d_%d", r - rec.x + 1, c - rec.y + 1)
            result[key] = v
            v.transForRect(rec)
        }
    }
    return result
}
BaseMapData.prototype.getGummyWormCfg = function (rec) {
    let self = this
    // body
    if (!rec) {
        return self.gummyWormCfg
    }
    if (!self.gummyWormCfg) {
        return table()
    }
    let result = table()
    for (let k in self.gummyWormCfg.gummyWormCfgs) {
        let v = self.gummyWormCfg.gummyWormCfgs[k]
        if ($null(v)) continue
        let arr = string.split(k, "_")
        let [r, c] = [tonumber(arr[1]), tonumber(arr[2])]
        if (cc.rectContainsPoint(rec, cc.p(r, c))) {
            let key = string.format("%d_%d", r - rec.x + 1, c - rec.y + 1)
            result[key] = v
            v.transForRect(rec)
        }
    }
    return result
}
BaseMapData.prototype.getFurballConfig = function (rec) {
    let self = this
    if (!rec) {
        return self.furballConfig
    }
    let furballConfig = table()
    if (!self.furballConfig) {
        return furballConfig
    }
    for (let k = 1, v = self.furballConfig[1]; v; k++, v = self.furballConfig[k]) {
        let bool = true
        let $limit246 = $len(v.link)
        for (let i = 1; i <= $limit246; i += 2) {
            let r = v.link[i]
            let c = v.link[i + 1]
            if (!cc.rectContainsPoint(rec, cc.p(r, c))) {
                bool = false
                break
            }
        }
        if (bool) {
            let configCopy = table.clone(v) //不是深拷贝需要改动
            configCopy.link = table.clone(v.link)


            let name = string.split(configCopy.name, "_")
            let name_r = tonumber(name[1]) - rec.x + 1
            let name_c = tonumber(name[2]) - rec.y + 1
            configCopy.name = name_r + "_" + name_c
            let $limit255 = $len(configCopy.link)
            for (let i = 1; i <= $limit255; i += 2) {
                configCopy.link[i] = configCopy.link[i] - rec.x + 1
                configCopy.link[i + 1] = configCopy.link[i + 1] - rec.y + 1
            }
            table.insert(furballConfig, configCopy)
        }
    }
    return furballConfig
}
BaseMapData.prototype.getSurfingCatConfig = function (rec) {
    let self = this
    if (!rec) {
        return self.surfingCatConfig
    }
    if (!self.surfingCatConfig) {
        return table()
    }
    let result = table()
    let $st156 = self.surfingCatConfig
    for (let k in $st156) {
        let v = $st156[k]
        if ($null(v)) continue
        let arr = string.split(k, "_")
        let [r, c] = [tonumber(arr[1]), tonumber(arr[2])]
        if (cc.rectContainsPoint(rec, cc.p(r, c))) {
            result[(r - rec.x + 1) + "_" + (c - rec.y + 1)] = v
        }
    }
    return result
}
BaseMapData.prototype.getColorCollectorConfig = function (rec) {
    let self = this
    if (!rec) {
        return self.colorCollectorConfig
    }
    if (!self.colorCollectorConfig) {
        return table()
    }
    let result = table()
    for (let k in self.colorCollectorConfig) {
        let v = self.colorCollectorConfig[k]
        if ($null(v)) continue
        let arr = string.split(k, "_")
        let [r, c] = [tonumber(arr[1]), tonumber(arr[2])]
        if (cc.rectContainsPoint(rec, cc.p(r, c))) {
            result[(r - rec.x + 1) + "_" + (c - rec.y + 1)] = v
        }
    }
    return result
}
BaseMapData.prototype.getFlashBirdConfig = function (rec) {
    let self = this
    if (!rec) {
        return self.flashBirdConfig
    }
    if (!self.flashBirdConfig) {
        return table()
    }
    let result = table()
    for (let k in self.flashBirdConfig) {
        let v = self.flashBirdConfig[k]
        if ($null(v)) continue
        let arr = string.split(k, "_")
        let [r, c] = [tonumber(arr[1]), tonumber(arr[2])]
        if (cc.rectContainsPoint(rec, cc.p(r, c))) {
            result[(r - rec.x + 1) + "_" + (c - rec.y + 1)] = v
        }
    }
    return result
}
BaseMapData.prototype.getSurpriseBoxConfig = function (rec) {
    let self = this
    if (!rec) {
        return self.surpriseBoxConfig
    }
    if (!self.surpriseBoxConfig) {
        return table()
    }
    let result = table()
    for (let k in self.surpriseBoxConfig) {
        let v = self.surpriseBoxConfig[k]
        if ($null(v)) continue
        let arr = string.split(k, "_")
        let [r, c] = [tonumber(arr[1]), tonumber(arr[2])]
        if (cc.rectContainsPoint(rec, cc.p(r, c))) {
            result[(r - rec.x + 1) + "_" + (c - rec.y + 1)] = v
        }
    }
    return result
}
BaseMapData.prototype.getSnowCordConfig = function (rec) {
    let self = this
    if (!rec) {
        return self.snowCordConfig
    }
    if (!self.snowCordConfig) {
        return table()
    }
    let result = table()
    for (let k in self.snowCordConfig) {
        let v = self.snowCordConfig[k]
        if ($null(v)) continue
        let arr = string.split(k, "_")
        let [r, c] = [tonumber(arr[1]), tonumber(arr[2])]
        if (cc.rectContainsPoint(rec, cc.p(r, c))) {
            result[(r - rec.x + 1) + "_" + (c - rec.y + 1)] = v
        }
    }
    return result
}
BaseMapData.prototype.getBigBoxConfig = function (rec) {
    let self = this
    if (!rec) {
        return self.bigBoxConfig
    }
    if (!self.bigBoxConfig) {
        return table()
    }
    let result = table()
    for (let k in self.bigBoxConfig) {
        let v = self.bigBoxConfig[k]
        if ($null(v)) continue
        let arr = string.split(k, "_")
        let [r, c] = [tonumber(arr[1]), tonumber(arr[2])]
        if (cc.rectContainsPoint(rec, cc.p(r, c))) {
            result[(r - rec.x + 1) + "_" + (c - rec.y + 1)] = v
        }
    }
    return result
}
BaseMapData.prototype.getGoldPackageConfig = function (rec) {
    let self = this
    // body
    if (!rec) {
        return self.goldPackageConfig
    }
    if (!self.goldPackageConfig) {
        return table()
    }
    let result = table()
    for (let k in self.goldPackageConfig) {
        let v = self.goldPackageConfig[k]
        if ($null(v)) continue
        let arr = string.split(k, "_")
        let [r, c] = [tonumber(arr[1]), tonumber(arr[2])]
        if (cc.rectContainsPoint(rec, cc.p(r, c))) {
            result[(r - rec.x + 1) + "_" + (c - rec.y + 1)] = v
        }
    }
    return result
}
BaseMapData.prototype.getBlockMachineConfig = function (rec) {
    let self = this
    if (!rec) {
        return self.blockMachineConfig
    }
    let blockMachineConfig = table()
    if (!self.blockMachineConfig) {
        return blockMachineConfig
    }
    for (let k in self.blockMachineConfig) {
        let v = self.blockMachineConfig[k]
        if ($null(v)) continue
        let arr = string.split(k, "_")
        if ($len(arr) === 2) {
            let [row, col] = [tonumber(arr[1]), tonumber(arr[2])]
            if (cc.rectContainsPoint(rec, cc.p(row, col))) {
                blockMachineConfig[(row - rec.x + 1) + "_" + (col - rec.y + 1)] = v
            }
        }
    }
    return blockMachineConfig
}
BaseMapData.prototype.initSpecial = function (data) {
    var self = this
    // body
}
BaseMapData.prototype.getDropRules = function () {
    var self = this //获取掉落规则
    var ret = table()
    for (var k = 1, v = self.dropRules[1]; v; k++ , v = self.dropRules[k]) {
        table.insert(ret, v.clone())
    }
    return ret
}
//-------------------------------
//添加需要的素材
//-------------------------------
BaseMapData.prototype.addMapNeedAssets = function (list, levelType) {
    var self = this
    // body
    let mapData = self.mapData
    // body
    for (let i in self.tileMap) {
        let v = self.tileMap[i]
        for (let j = 1, d = v.defs[1]; d; j++ , d = v.defs[j]) {
            if (d.furballType > 0) {
                // list["flash/cat.plist"] = true
                // list["flash/cat.png"] = true
                list["flash/furball.plist"] = true
                list["flash/furball.png"] = true

                continue;
            }
            let itemType = tonumber(d.itemType)
            if (itemType == GameItemType.kSurfingCat) {
                list["packed/BaseSurfringCatNeedAssets.pack"] = true
            } else if (itemType >= GameItemDefMapKey.kColorCollector_0 && itemType <= GameItemDefMapKey.kColorCollector_6) {
                list["packed/BaseColorCollectorNeedAssets.pack"] = true
            } else if (itemType >= GameItemDefMapKey.kCake_1 && itemType <= GameItemDefMapKey.kCake_8) {
                list["packed/BaseCakeNeedAssets.pack"] = true
            } else if (itemType == GameItemDefMapKey.kBlockMachine) {
                list["packed/BaseBlockMachineAssets.pack"] = true
            } else if (itemType >= GameItemDefMapKey.kBowknot_1 && itemType <= GameItemDefMapKey.kBowknot_5) {
                list["packed/BaseBowknotAssets.pack"] = true
            } else if (itemType >= GameItemDefMapKey.kSurpriseBox_1 && itemType <= GameItemDefMapKey.kSurpriseBonus) {
                // 2级盒子消除后会产生1级盒子
                // surpriseBox.plist中包含target图标
                list['flash/surpriseBox.plist'] = true
                // list['flash/surpriseBox_2.plist'] = true
            } else if (itemType == GameItemDefMapKey.kLighthouse) {
                list['flash/lighthouse.plist'] = true
                list['flash/lighthouse_bee.plist'] = true
            }
            let assets = MapResConfig.DependingAssetsTypeNameMap[d.id]
            if (assets) {
                for (let _ = 0, n = assets[0]; n; _++ , n = assets[_]) {
                    list[n] = true
                }
            }
        }
    }
    //--------掉落素材
    for (let k in mapData.dropRules) {
        let v = mapData.dropRules[k]
        if ($null(v)) continue
        self.addDependingAssetsByDefId(list, v.itemID)
        if (v.lockId) {
            self.addDependingAssetsByDefId(list, v.lockId)
        }
        if (v.capsuleToy_id) {
            self.addDependingAssetsByDefId(list, v.capsuleToy_id)
        }
    }
    if (mapData.portals && $len(mapData.portals) > 0) {
        list["flash/link_item.plist"] = true
    }
    //绳子，冰柱
    if (mapData.edgeMap) {
        for (let k in mapData.edgeMap) {
            let v = mapData.edgeMap[k]
            if ($null(v)) continue
            var def = GameItemDefManager.getDef(v)
            if (def.itemType === GameItemType.kChain) {
                list["flash/ice_chain.plist"] = true
            }
        }
    }
    //传送带
    if (mapData.trans) {
        list["flash/transfer.plist"] = true
    }
    if (mapData.orderList) {
        for (let k in mapData.orderList) {
            let v = mapData.orderList[k]
            if ($null(v)) continue
            var arr = string.split(v, "_")
            self.addDependingAssetsByDefId(list, tonumber(arr[1]))
        }
    }
    if (mapData.variousBoxData) {
        for (let k in mapData.variousBoxData) {
            let v = mapData.variousBoxData[k]
            if ($null(v)) continue
            self.addDependingAssetsByDefId(list, v.id)
        }
    }
    if (mapData.ufoData) {
        for (let k in mapData.ufoData) {
            let v = mapData.ufoData[k]
            if ($null(v)) continue
            self.addDependingAssetsByDefId(list, v.id)
        }
    }
    if (mapData.capsuleToyData) {
        for (let k in mapData.capsuleToyData) {
            let v = mapData.capsuleToyData[k]
            if ($null(v)) continue
            self.addDependingAssetsByDefId(list, v.id)
        }
    }
    if (mapData.grassData) {
        for (let k in mapData.grassData) {
            let v = mapData.grassData[k]
            if ($null(v)) continue
            self.addDependingAssetsByDefId(list, v.id)
        }
    }
    if (mapData.dinnertableData) {
        for (let k in mapData.dinnertableData) {
            let v = mapData.dinnertableData[k]
            if ($null(v)) continue
            self.addDependingAssetsByDefId(list, v.id)
        }
    }
    if (mapData.laserData) {
        for (let k in mapData.laserData) {
            let v = mapData.laserData[k]
            if ($null(v)) continue
            self.addDependingAssetsByDefId(list, v.id)
        }
    }
    if (mapData.hunterData) {
        for (let k in mapData.hunterData) {
            let v = mapData.hunterData[k]
            if ($null(v)) continue
            self.addDependingAssetsByDefId(list, v.id)
        }
    }
    if (mapData.safeData) {
        for (let k in mapData.safeData) {
            let v = mapData.safeData[k]
            if ($null(v)) continue
            self.addDependingAssetsByDefId(list, v.id)
        }
    }
    if (mapData.torpedoData) {
        for (let k in mapData.torpedoData) {
            let v = mapData.torpedoData[k]
            if ($null(v)) continue
            self.addDependingAssetsByDefId(list, v.id)
        }
    }
    if (mapData.magicbottleData) {
        for (let k in mapData.magicbottleData) {
            let v = mapData.magicbottleData[k]
            if ($null(v)) continue
            self.addDependingAssetsByDefId(list, v.id)
        }
    }
    if (mapData.iceBombData) {
        for (let k in mapData.iceBombData) {
            let v = mapData.iceBombData[k]
            if ($null(v)) continue
            self.addDependingAssetsByDefId(list, v.id)
        }
    }
    if (mapData.randomTileData) {
        for (let k in mapData.randomTileData) {
            let v = mapData.randomTileData[k]
            if ($null(v)) continue
            for (let _ = 1, tileData = v[1]; tileData; _++ , tileData = v[_]) {
                self.addRandomTileNeedAssets(list, tileData)
            }
        }
    }

    if (mapData.blockMachineData) {
        for (let k in mapData.blockMachineData) {
            let v = mapData.blockMachineData[k]
            if ($null(v)) continue
            self.addDependingAssetsByDefId(list, v.itemId)
        }
    }

    if (mapData.spawnOtherData) {
        for (let k in mapData.spawnOtherData) {
            let v = mapData.spawnOtherData[k]
            if ($null(v)) continue
            if (v.markData) {
                // list["cocos/produce_mark.plist"] = true
                // list["cocos/block_machine.plist"] = true
                list["packed/BaseProduceMarkAssets.pack"] = true
            }
        }
    }
    if (mapData.candyFlossCfg && $len(mapData.candyFlossCfg) > 0) {
        list["cocos/candy_floss.plist"] = true
        list["cocos/candy_floss_boom.csb"] = true
    }
    if (mapData.nestCfg && $len(mapData.nestCfg) > 0) {
        // list["cocos/candy_floss.plist"] = true
        // list["cocos/popcorn.plist"] = true
        let assets = MapResConfig.DependingAssetsTypeNameMap[GameItemDefMapKey.kNest]
        if (assets) {
            for (let _ = 0, n = assets[0]; n; _++ , n = assets[_]) {
                list[n] = true
            }
        }
    }
    if (mapData.gummyWormCfg && $len(mapData.gummyWormCfg) > 0) {
        list["packed/GummyWormMapNeedAssets.pack"] = true
    }
    //list["flash/bonustime_blast.plist"] = true
    list["cocos/clover_animation.plist"] = true
    // if (levelType && levelType === GameLevelType.kIslandLevel) {
    //     list["flash/prop_bottle_fg.plist"] = true
    //     list["flash/bomb.plist"] = true
    // }
    if ((mapData.candyYoyoCfg && $len(mapData.candyYoyoCfg) > 0)) {
        self.addDependingAssetsByDefId(list, GameItemDefMapKey.kCandyYoyo)

    }
    if (mapData.turnTileData) {
        let keys = table(
            [0, TurnTileConst.kAF],
            [0, TurnTileConst.kAB],
            [0, TurnTileConst.kBF],
            [0, TurnTileConst.kBB]
        )
        for (let _ in keys) {
            let key = keys[_]
            if ($null(key)) continue
            if (mapData.turnTileData && mapData.turnTileData[key]) {
                for (let k in mapData.turnTileData[key]) {
                    let v = mapData.turnTileData[key][k]
                    if ($null(v)) continue
                    for (let k2 in v) {
                        let v2 = v[k2]
                        if ($null(v2)) continue
                        self.addDependingAssetsByDefId(list, v2)
                    }
                }
            }
        }
    }
}

// 添加想要预填充csb对象池的类
BaseMapData.prototype.addPrefillAnimationClazz = function (prefillAnimationMap, gameMode) {
    let self = this
    let mapData = self.mapData
    if ((mapData.mintCfg && $len(mapData.mintCfg) > 0)) {
        let TileMint = require("clover/animation/TileMint")
        TileMint.prefillAniMapData = mapData.mintCfg
        TileMint.prefillAniGameMode = gameMode
        if (!prefillAnimationMap.classDefines)
        {
            prefillAnimationMap.classDefines = []
        }
        prefillAnimationMap.classDefines.push(TileMint)
    }
}
BaseMapData.prototype.getNeedMusics = function () {
    let self = this
    return table()
}
//------------------------------------------------------------------------
//child
//------------------------------------------------------------------------
OrderMapData = xClass("OrderMapData", BaseMapData)
OrderMapData.prototype.initSpecial = function (data) {
    var self = this
    // body
    self.orderMap = data.orderList
}
OrderMapData.prototype.getNeedMusics = function () {
    let self = this
    let musics = table()
    table.insert(musics, GameMusicType.kModeOrderAnimalAppear)
    table.insert(musics, GameMusicType.kModeOrderBottleSlide)
    table.insert(musics, GameMusicType.kModeOrderJellyFall)
    table.insert(musics, GameMusicType.kModeOrderTargetFinish)
    table.insert(musics, GameMusicType.kModeOrderTargetFlyToBottle)
    table.insert(musics, GameMusicType.kModeOrderThingsFall)
    table.insert(musics, GameMusicType.kModeOrderThingsFall_1)
    return musics
}
OrderMapData.prototype.addMapNeedAssets = function (list, levelType, isPvp = false) {
    let self = this
    // body
    BaseMapData.prototype.addMapNeedAssets.call(self, list, levelType)
    // if (levelType && levelType === GameLevelType.kIslandLevel) { } else {
        // list["cocos/fox_finish.plist"] = true
        // list["cocos/bear_finish.plist"] = true
        // list["cocos/frog_finish.plist"] = true
        // list["cocos/racoon_finish.plist"] = true
        list["cocos/order.plist"] = true
        list["packed/orderMapNeedAssets.pack"] = true
        for (var k in self.orderMap) {
            var v = self.orderMap[k]
            var arr = string.split(v, "_")
            var def = GameItemDefManager.getDef(parseInt(arr[1], 0))
            var res = MapResConfig.OrderTargetResMap[def.itemType || def.id]
            res && res.forEach(r => {
                list[r] = true
            })
        }
    // }

    if (isPvp){
        list["packed/LimitTimeAimClockRes.pack"] = true;
        list["packed/PvpTargetProgressRes.pack"] = true;
        list["packed/levelComCsb.pack"] = null;
        list["packed/levelExtPlist.pack"] = null;
        list["packed/levelComCsbForPvp.pack"] = true;
        list["packed/levelExtPlistForPvp.pack"] = true;
    }
}

IceMapData = xClass("IceMapData", OrderMapData)
IceMapData.prototype.initSpecial = function (data) {
    var self = this
    // body
    self.iceRate = data.iceRate
    self.orderMap = data.orderList
}
IceMapData.prototype.addMapNeedAssets = function (list, levelType, isPvp = false) {
    let self = this
    // body
    // BaseMapData.addMapNeedAssets(self, list, levelType)
    OrderMapData.prototype.addMapNeedAssets.call(self, list, levelType)
    // 虽继承自OrderMode但不需要此图
    list["cocos/order.plist"] = null
    list["packed/IceMapNeedAssets.pack"] = true

    if (isPvp){
        list["packed/LimitTimeAimClockRes.pack"] = true;
        list["packed/PvpTargetProgressRes.pack"] = true;
        list["packed/levelComCsb.pack"] = null;
        list["packed/levelExtPlist.pack"] = null;
        list["packed/levelComCsbForPvp.pack"] = true;
        list["packed/levelExtPlistForPvp.pack"] = true;
    }
}
IceMapData.prototype.getNeedMusics = function () {
    var musics = table()
    table.insert(musics, GameMusicType.kModeIceShovelIcecream)
    table.insert(musics, GameMusicType.kModeIceWhistle)
    table.insert(musics, GameMusicType.kModeIceFinishOneTarget)
    table.insert(musics, GameMusicType.kModeIceFruitFly)
    table.insert(musics, GameMusicType.kModeIceChickenAppear)
    table.insert(musics, GameMusicType.kModeIcePassMission)
    table.insert(musics, GameMusicType.kModeIceFruitOut)
    table.insert(musics, GameMusicType.kModeIceFogSpray)
    return musics
}
FishMapData = xClass("FishMapData", BaseMapData)
FishMapData.prototype.initSpecial = function (data) {
    var self = this
    // body
    self.orderMap = data.orderList
    self.roadType = RoadType.kFish
    self.fish = data.fish
    self.path = data.path
    self.punish_new = data.punish_new
    self.excited_new = data.excited_new
    self.recycle_new = data.recycle_new
    self.fish_mode_rule = data.fish_mode_rule || table()
    self.fish_mode_rule.isAlphaMode = true
    self.new_fish_rule = data.new_fish_rule
}
FishMapData.prototype.addMapNeedAssets = function (list, levelType, isPvp = false) {
    var self = this
    BaseMapData.prototype.addMapNeedAssets.call(self, list, levelType)
    // if (levelType && levelType === GameLevelType.kIslandLevel) { } else {
    //     list["flash/fish_light.plist"] = true
    //     list["cocos/clover_animation_fish.plist"] = true
    //     list["materials/bg_fish.plist"] = true
    // }
    // list["flash/stone_combine.plist"] = true
    // list["flash/fish_combine.plist"] = true
    // list["flash/mapLight.plist"] = true
    // list["flash/water.plist"] = true
    // list["flash/water_decor.plist"] = true
    list["packed/FishMapNeedAssets.pack"] = true

    if (isPvp){
        list["packed/LimitTimeAimClockRes.pack"] = true;
        list["packed/PvpTargetProgressRes.pack"] = true;
        list["packed/levelComCsb.pack"] = null;
        list["packed/levelExtPlist.pack"] = null;
        list["packed/levelComCsbForPvp.pack"] = true;
        list["packed/levelExtPlistForPvp.pack"] = true;
    }
}
FishMapData.prototype.getNeedMusics = function () {
    let self = this
    var musics = table()
    table.insert(musics, GameMusicType.kModeFishCatPull)
    table.insert(musics, GameMusicType.kModeFishFishFly)
    table.insert(musics, GameMusicType.kModeFishFishSpring)
    table.insert(musics, GameMusicType.kModeFishFishSwim)
    return musics
}
BossMapData = xClass("BossMapData", BaseMapData)
// BossMapData.prototype.initWithData = function (mapData) {
//     var self = this
//     BaseMapData.prototype.initWithData.call(self, mapData)
//     // BaseMapData.prototype.loadData.call(self, null)
//     self.initSpecial(mapData)
// }
BossMapData.prototype.initSpecial = function (data) {
    var self = this
    self.bossData = data.boss
}
BossMapData.prototype.addMapNeedAssets = function (list, levelType, isPvp = false) {
    var self = this
    // body
    BaseMapData.prototype.addMapNeedAssets.call(self, list, levelType)
    let bossData = self.mapData.boss
    if (bossData) {
        let bossInfo = bossData.bossList[1]
        if (bossInfo.skills && $len(bossInfo.skills) > 0) {
            list["packed/BigBossMapNeedAssets.pack"] = true
            for (let k = 1, v = bossInfo.skills[1]; v; k++, v = bossInfo.skills[k]) {
                cc.log(v.mType)
                self.addDependingAssetsByDefId(list, v.mType)
            }
        }
    }
    // if (levelType && levelType === GameLevelType.kIslandLevel) { } else {
    //     list["flash/bomb.plist"] = true
    //     list["flash/lighthouse.plist"] = true
    //     list["flash/lighthouse_bee.plist"] = true
    //     list["flash/starfish.plist"] = true
    //     list["cocos/boss_bg.plist"] = true
    //     list["cocos/boss_common_res.plist"] = true
    //    list["cocos/clover_animation_octopus.plist"] = true
    // }
    //总是存在
    list["packed/SmallBossMapNeedAssets.pack"] = true
    list["packed/BossMapCommonNeedAssets.pack"] = true

    // 根据动物按需加载
    self.bossData.petList.forEach(pet => pet && addToResMap(list, MapResConfig.PetResMap[pet]))

    if (isPvp){
        list["packed/LimitTimeAimClockRes.pack"] = true;
        list["packed/PvpTargetProgressRes.pack"] = true;
        list["packed/levelComCsb.pack"] = null;
        list["packed/levelExtPlist.pack"] = null;
        list["packed/levelComCsbForPvp.pack"] = true;
        list["packed/levelExtPlistForPvp.pack"] = true;
    }
}
BossMapData.prototype.getNeedMusics = function () {
    let __VA_ARG = $slice(arguments, 0)
    let self = this
    // body
    var musics = table()
    table.insert(musics, GameMusicType.kBossAppear)
    table.insert(musics, GameMusicType.kAnimalAttackBoss)
    table.insert(musics, GameMusicType.kBossPreWarning)
    table.insert(musics, GameMusicType.kBigBossBeHeavyHit)
    table.insert(musics, GameMusicType.kSmallBossBeHeavyHit)
    table.insert(musics, GameMusicType.kPetAttack_1)
    table.insert(musics, GameMusicType.kPetAttack_2)
    table.insert(musics, GameMusicType.kPetAttack_3)
    table.insert(musics, GameMusicType.kPetAttack_4)
    table.insert(musics, GameMusicType.kPetAttack_5)
    table.insert(musics, GameMusicType.kPetAttack_6)
    table.insert(musics, GameMusicType.kBossBlockAttack)
    return musics
}
BlockCollectionMapData = xClass("BlockCollectionMapData", OrderMapData)
BlockCollectionMapData.prototype.addMapNeedAssets = function (list, levelType, isPvp = false) {
    var self = this
    cc.log("==========BlockCollectionMapData========self.needAddAimLimit", self.needAddAimLimit);
    // body
    OrderMapData.prototype.addMapNeedAssets.call(self, list, levelType)
    // 虽继承自OrderMode但不需要此图
    list["cocos/order.plist"] = null
    // if (levelType && levelType === GameLevelType.kIslandLevel) { } else {
    //     list["cocos/block_target_anim_res.plist"] = true
    // }
    // list["flash/blco_target.plist"] = true   
    list["packed/BlockCollectionMapNeedAssets.pack"] = true
    if (self.needAddAimLimit){
        list["packed/LimitTimeAimClockRes.pack"] = true;
    }

    if (isPvp){
        list["packed/LimitTimeAimClockRes.pack"] = true;
        list["packed/PvpTargetProgressRes.pack"] = true;
        list["packed/levelComCsb.pack"] = null;
        list["packed/levelExtPlist.pack"] = null;
        list["packed/levelComCsbForPvp.pack"] = true;
        list["packed/levelExtPlistForPvp.pack"] = true;
    }
}
BlockCollectionMapData.prototype.needAimLimit = function(){
    var self = this
    self.needAddAimLimit = true;
}

BlockCollectionMapData.prototype.getNeedMusics = function () {
    var self = this
    var music = OrderMapData.prototype.getNeedMusics.call(self)
    table.insert(music, GameMusicType.kModeCollectThingsFall)
    return music
}
DropDigMapData = xClass("DropDigMapData", OrderMapData)
DropDigMapData.prototype.addMapNeedAssets = function (list, levelType, isPvp = false) {
    var self = this
    // body
    OrderMapData.prototype.addMapNeedAssets.call(self, list, levelType)
    // 虽继承自OrderMode但不需要此图
    list["cocos/order.plist"] = null
    
    list["flash/dropdig_low.plist"] = true

    if (isPvp){
        list["packed/LimitTimeAimClockRes.pack"] = true;
        list["packed/PvpTargetProgressRes.pack"] = true;
        list["packed/levelComCsb.pack"] = null;
        list["packed/levelExtPlist.pack"] = null;
        list["packed/levelComCsbForPvp.pack"] = true;
        list["packed/levelExtPlistForPvp.pack"] = true;
    }
}
WaterDigMapData = xClass("WaterDigMapData", OrderMapData)
WaterDigMapData.prototype.addMapNeedAssets = function (list, levelType, isPvp = false) {
    let self = this
    // body
    OrderMapData.prototype.addMapNeedAssets.call(self, list, levelType)
    // 虽继承自OrderMode但不需要此图
    list["cocos/order.plist"] = null
    list["packed/WaterDigMapNeedAssets.pack"] = true
    // if (levelType && levelType === GameLevelType.kIslandLevel) { } else {
    //     list["cocos/water_dig_fish.plist"] = true
    //     list["cocos/water_dig_mode.plist"] = true
    //     list["cocos/water_dig_in_pre.plist"] = true
    //     list["cocos/water_bubble.plist"] = true
    // }
    // list["flash/dropdig.plist"] = true
    // list["flash/waterdig.plist"] = true
    // list["flash/waterdig_water.plist"] = true

    if (isPvp){
        list["packed/LimitTimeAimClockRes.pack"] = true;
        list["packed/PvpTargetProgressRes.pack"] = true;
        list["packed/levelComCsb.pack"] = null;
        list["packed/levelExtPlist.pack"] = null;
        list["packed/levelComCsbForPvp.pack"] = true;
        list["packed/levelExtPlistForPvp.pack"] = true;
    }
}
PursueMapData = xClass("PursueMapData", BaseMapData)
PursueMapData.prototype.initSpecial = function (data) {
    let self = this
    // body
    self.roadType = RoadType.kPursue
    self.path = data.path
}
PursueMapData.prototype.addMapNeedAssets = function (list, levelType, isPvp = false) {
    let self = this
    BaseMapData.prototype.addMapNeedAssets.call(self, list, levelType)
    // list["flash/pursue.plist"] = true
    // if (levelType && levelType === GameLevelType.kIslandLevel) {
    //     list["flash/pursue_role_main_e.plist"] = true
    //     list["flash/pursue_role_main_s.plist"] = true
    //     list["cocos/blast_crystal.plist"] = true
    //     list["flash/bomb.plist"] = true
        // list["flash/pursue_role_activity_s.plist"] = true
        // list["cocos/shake_ribbon.plist"] = true
    //     list["cocos/shake_ribbon.plist"] = true
    // } else {
    //     list["cocos/pursue_target_main.plist"] = true
    //     list["cocos/pursue_target_main_res.plist"] = true
    //     list["flash/pursue_role_main_e.plist"] = true
    //     list["flash/pursue_role_main_s.plist"] = true
    // }
    list["packed/PursueMapNeedAssets.pack"] = true

    if (isPvp){
        list["packed/LimitTimeAimClockRes.pack"] = true;
        list["packed/PvpTargetProgressRes.pack"] = true;
        list["packed/levelComCsb.pack"] = null;
        list["packed/levelExtPlist.pack"] = null;
        list["packed/levelComCsbForPvp.pack"] = true;
        list["packed/levelExtPlistForPvp.pack"] = true;
    }
}
GoldMapData = xClass("GoldMapData", OrderMapData)
GoldMapData.prototype.addMapNeedAssets = function (list, levelType) {
    let self = this
    // body
    // list["cocos/Gold.plist"] = true
    // list["cocos/gold_package.plist"] = true
    list["packed/GoldMatchActivityRes.pack"] = true
    list["packed/TimeModeActivityRes.pack"] = true
    list["packed/levelExtPlist.pack"] = null
    list["packed/levelExtPlistForGoldMatch.pack"] = true
    list["packed/levelExtCsbForGoldMatch.pack"] = true
    OrderMapData.prototype.addMapNeedAssets.call(self, list, levelType)
}
GoldMapData.prototype.fixGameData = function () {
    let __VA_ARG = $slice(arguments, 0)
    let self = this
    // body
    let mapData = self.mapData
    for (let _ in mapData.tileMap) {
        let v = mapData.tileMap[_]
        if ($null(v)) continue
        for (let _k = 1, d = v[1]; d; _k++, d = v[_k]) {
            if (tonumber(d) === GameItemDefMapKey.kSilver) {
                table.remove(v, _k)
                table.insert(v, GameItemDefMapKey.kGold)
            }
        }
    }
}

PvpMapData = xClass("PvpMapData", OrderMapData)
PvpMapData.prototype.addMapNeedAssets = function (list) {
    let self = this
    OrderMapData.prototype.addMapNeedAssets.call(self, list)
    list["packed/PvpMapNeedAssets.pack"] = true
    list["packed/PvpTargetProgressRes.pack"] = true
}

OneStepMapData = xClass("OneStepMapData", OrderMapData)
OneStepMapData.prototype.addMapNeedAssets = function (list) {
    let self = this
    OrderMapData.prototype.addMapNeedAssets.call(self, list)
    list["packed/GameItemTypeKVar_Snow.pack"] = true
    list["packed/ChallengeActivityRes.pack"] = true
}

TimeBlockCollectionMapData = xClass("TimeBlockCollectionMapData", BlockCollectionMapData)
TimeBlockCollectionMapData.prototype.addMapNeedAssets = function (list) {
    let self = this
    BlockCollectionMapData.prototype.addMapNeedAssets.call(self, list)
    list["packed/TimeModeActivityRes.pack"] = true
}
